import type { SummarySource } from "./api/selectSummarySource";

/**
 * Who sends the session summary to the partner tool:
 *  - `frontend`: this browser dispatches `SessionSummary_Submit`.
 *  - `backend-gaia`: session-summary-sender sends it. GAIA reports its own summaries to the sender, so the
 *    browser sends nothing.
 *
 * With `sendSummaryFromBackend` on (Verizon), a Simplr-served summary still goes out from the browser:
 * session-summary-sender only consumes GAIA orchestrator events, so it never sees Simplr's summary.
 */
export type SummaryDelivery = "frontend" | "backend-gaia";

export const selectSummaryDelivery = ({
    sendSummaryFromBackend,
    servedBy,
}: {
    sendSummaryFromBackend: boolean;
    servedBy: SummarySource;
}): SummaryDelivery => {
    if (!sendSummaryFromBackend) return "frontend";
    return servedBy === "simplr" ? "frontend" : "backend-gaia";
};
